import * as React from 'react';
import SVGUniqueID from 'react-svg-unique-id';

const SemiFilledRingIcon = (props) => (
  <SVGUniqueID>
    <svg
      width={41}
      height={40}
      viewBox="0 0 41 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_1024_17176)">
        <path
          d="M40.5 20C40.5 31.0457 31.5457 40 20.5 40C9.4543 40 0.5 31.0457 0.5 20C0.5 8.9543 9.4543 0 20.5 0C31.5457 0 40.5 8.9543 40.5 20ZM5.5 20C5.5 28.2843 12.2157 35 20.5 35C28.7843 35 35.5 28.2843 35.5 20C35.5 11.7157 28.7843 5 20.5 5C12.2157 5 5.5 11.7157 5.5 20Z"
          fill="#E2E8F0"
        />
        <path
          d="M20.5 2.5C20.5 1.11929 21.6236 -0.0161077 22.9936 0.156036C26.2942 0.57079 29.4534 1.80444 32.1757 3.76181C35.5774 6.20777 38.1251 9.66031 39.4592 13.6321C40.7932 17.6039 40.8462 21.8944 39.6106 25.8979C38.6218 29.1017 36.8479 31.9922 34.4668 34.3153C33.4785 35.2796 31.8973 35.0526 31.0639 33.9519C30.2304 32.8511 30.466 31.2954 31.4132 30.2909C32.9792 28.6302 34.1534 26.6254 34.8329 24.4234C35.7596 21.4208 35.7199 18.2029 34.7194 15.2241C33.7189 12.2452 31.8081 9.65583 29.2567 7.82136C27.3857 6.47602 25.2394 5.58654 22.9885 5.20785C21.6269 4.97878 20.5 3.88071 20.5 2.5Z"
          fill="#6A0B1F"
        />
      </g>
      <defs>
        <clipPath id="clip0_1024_17176">
          <rect
            width={40}
            height={40}
            fill="white"
            transform="translate(0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  </SVGUniqueID>
);
export { SemiFilledRingIcon };
